<template>
  <div class="banner">
    <div
      :style="{
        backgroundImage: `url(${ad.url ||
          'https://static-web.hzmk.site/as/bigo-static/www.bigo.tv/img/video-bg.jpg'})`
      }"
      class="banner-link"
      :class="{ 'is--pointer': ad.go_url }"
      @click="goAd"
    ></div>
    <div class="banner-section">
      <Player ref="player" :current="current" show-enter-room></Player>

      <div class="swiper-container">
        <!-- <div class="swiper-container__wrapper"> -->
        <div class="swiper-wrapper swiper-wrapper-scroll">
          <div
            v-for="recommend in recommendArr"
            :key="recommend.bigoID || recommend.bigo_id"
            ref="swiperSlide"
            class="swiper-slide"
            :class="{
              'is--current':
                (current.bigoID || current.bigo_id) ===
                (recommend.bigoID || recommend.bigo_id)
            }"
            @click="changeCurrent(recommend)"
          >
            <div
              v-if="recommend.cover_l"
              v-lazy:background-image="recommend.cover_l"
              class="cover-bg"
            ></div>
            <!-- <img v-lazy="recommend.cover_url || recommend.data5" /> -->
            <div class="opa-bg"></div>
          </div>
        </div>

        <div
          v-if="showUpTips"
          class="arrow-tips-down arrow-tips-up"
          @click="scroll('prev')"
        ></div>
        <div
          v-if="showDownTips"
          class="arrow-tips-down"
          @click="scroll('next')"
        ></div>
        <!-- </div> -->

        <!-- <div class="swiper-button-prev" @click="prev"></div>
        <div class="swiper-button-next" @click="next"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@components/Player';
import api from '@services';
import { getCountryCode } from '@assets/js/utils';

export default {
  name: 'Banner',
  components: {
    Player
  },
  data() {
    return {
      current: {},
      recommendArr: [],
      // 广告banner
      ads: [],
      swiperOptions: {
        currentIndex: 0,
        currentWidth: 0,
        wrapperStyle: {},
        slidesPerView: 5
      },
      showUpTips: false,
      showDownTips: true
    };
  },
  computed: {
    ad() {
      return this.ads?.[0] || {};
    }
  },
  watch: {
    'swiperOptions.currentIndex'(n) {
      const translateX = n * this.swiperOptions.currentWidth;
      this.$set(
        this.swiperOptions.wrapperStyle,
        'transform',
        `translate(-${translateX}px, 0)`
      );
    }
  },
  mounted() {
    // 没有实现该接口
    this.getAd();
    this.getList();
  },
  methods: {
    scroll(type) {
      const scrolldom = document.getElementsByClassName(
        'swiper-wrapper-scroll'
      )[0];
      if (scrolldom) {
        const baseY = scrolldom.getBoundingClientRect().top;

        const d = document.querySelectorAll(
          '.swiper-wrapper-scroll .swiper-slide'
        );
        let currentScrollDom = 0;
        for (let i = 0; i < d.length; i++) {
          if (d[i].getBoundingClientRect().top <= baseY) {
            currentScrollDom = i;
          }
        }
        if (type === 'prev' && d[currentScrollDom - 1]) {
          d[currentScrollDom - 1].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        } else if (type === 'next' && d[currentScrollDom + 5]) {
          d[currentScrollDom + 5].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }
    },
    scrollListener() {
      setTimeout(() => {
        const scrolldom = document.getElementsByClassName(
          'swiper-wrapper-scroll'
        )[0];

        if (scrolldom) {
          scrolldom.addEventListener('scroll', () => {
            const baseY = scrolldom.getBoundingClientRect().top;
            const d = document.querySelectorAll(
              '.swiper-wrapper-scroll .swiper-slide'
            );
            if (d[0].getBoundingClientRect().top === baseY) {
              this.showUpTips = false; // 滚动到顶部
            } else {
              this.showUpTips = true;
            }

            if (d[d.length - 1].getBoundingClientRect().top - baseY < 520) {
              this.showDownTips = false;
            } else {
              this.showDownTips = true;
            }
          });
        }
      });
    },
    prev() {
      if (this.swiperOptions.currentIndex === 0) return;
      this.swiperOptions.currentIndex -= 1;
    },
    next() {
      if (
        this.swiperOptions.currentIndex + this.swiperOptions.slidesPerView >=
        this.recommendArr.length - 1
      )
        return;
      this.swiperOptions.currentIndex += 1;
    },
    setWrapperStyle() {
      const count = this.recommendArr.length;
      const swiperSlides = this.$refs.swiperSlide;
      if (swiperSlides && swiperSlides[0]) {
        const item = swiperSlides[0];
        const width = count * (item.offsetWidth + 20);
        this.swiperOptions.currentWidth = item.offsetWidth + 20;
        this.swiperOptions.wrapperStyle = {
          width: width + 'px'
        };
      }
    },
    goAd() {
      if (!this.ad.go_url) return;
      window.open(this.ad.go_url, '_blank');
    },
    changeCurrent(item) {
      this.current = item;
      this.switchLive();
    },
    switchLive() {
      this.$refs.player.switchLive({
        app: 'bigo',
        siteid: this.current.bigo_id || this.current.bigoID
      });
    },
    startLive() {
      this.$refs.player.startLive({
        app: 'bigo',
        siteid: this.current.bigo_id || this.current.bigoID
      });
    },
    async getList() {
      let countryCode = getCountryCode(this.$i18n.locale, true);
      if (this.$i18n.locale === 'cn' || this.$i18n.locale === 'tw') {
        countryCode = undefined; // cn与tw游戏直播，展示ALL的
      }
      const res = await api.getGamingList({
        tabType: '00',
        fetchNum: 16,
        countryCode,
        lang: this.$i18n.locale
      });
      const data = res ? res.data : [];
      this.recommendArr = data;
      if (data.length < 6) {
        this.showDownTips = false;
        this.showUpTips = false;
      }
      this.current = data[0] || {};

      if (process.client) {
        this.startLive();
        this.$nextTick(this.setWrapperStyle);
        this.scrollListener();
      }
    },
    // 获取广告位banner背景
    async getAd() {
      const data = await this.$api.getAd();
      this.ads = data?.bg || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  min-width: 1340px;
  height: 724px;
  background-color: #151818;
  background-repeat: no-repeat;
  background-position: center top;
  background-image: url('~@/assets/img/banner-bg.jpg');
  background-size: cover;

  .banner-link {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: center no-repeat;
    background-size: cover;

    &.is--pointer {
      cursor: pointer;
    }
  }

  .banner-section {
    width: 1342px;
    height: 628px;
    margin: 0 auto;
    position: relative;
    z-index: 8;
    top: 48px;
    display: flex;
    justify-content: center;
    align-items: center;

    .swiper-container {
      margin-left: 7px;
      margin-right: 7px;
      width: 213px;
      height: 100%;
      position: relative;

      .arrow-tips-down {
        position: absolute;
        bottom: 5px;
        left: 0;
        right: 0;
        z-index: 100;
        margin: 0 auto;
        width: 32px;
        height: 32px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        background-image: url('~@assets/img/arrow_tips.png');
        cursor: pointer;

        &.arrow-tips-up {
          transform: rotateZ(180deg);
          -webkit-transform: rotateZ(180deg);
          -moz-transform: rotateZ(180deg);
          bottom: auto;
          top: 5px;
        }
      }

      // .swiper-container__wrapper {
      //   overflow: hidden;
      // }

      .swiper-button-prev,
      .swiper-button-next {
        position: absolute;
        width: 14px;
        height: 24px;
        top: 35px;
        cursor: pointer;
      }

      .swiper-button-prev {
        left: 0;
        transform: translate3d(-100%, 0, 0);
        background: url('~@/assets/img/icon2.png') -1px -223px no-repeat;
      }

      .swiper-button-prev:hover {
        background: url('~@/assets/img/icon2.png') -19px -223px no-repeat;
      }

      .swiper-button-next {
        right: 0;
        transform: translate3d(100%, 0, 0);
        background: url('~@/assets/img/icon2.png') -2px -255px no-repeat;
      }

      .swiper-button-next:hover {
        background: url('~@/assets/img/icon2.png') -20px -255px no-repeat;
      }

      .swiper-wrapper {
        // width: 100%;
        height: 100%;
        // margin: auto;
        // overflow: hidden;
        position: relative;
        transition: all 0.5s;
        display: flex;
        // justify-content: center;
        // align-items: center;
        flex-direction: column;
        overflow-y: scroll;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */

        .swiper-slide {
          // flex: 1;
          flex-shrink: 0;
          width: 100%;
          height: 120px;
          // float: left;
          // margin: 0 10px;
          margin-bottom: 7px;
          cursor: pointer;
          position: relative;
          border-radius: 4px;
          // overflow: hidden;
          // border: 2px rgba(255, 255, 255, 0) solid;

          &.is--current .opa-bg,
          &:hover .opa-bg {
            opacity: 0;
            filter: alpha(opacity=0);
          }

          &.is--current {
            border: 3px rgba(255, 255, 255, 1) solid;
          }

          img {
            display: block;
            max-width: 100%;
            max-height: 100%;
            margin: auto;
            position: relative;
            z-index: 2;
            // overflow: hidden;
          }

          .cover-bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius: 4px;
            background-position: center center;
          }

          .opa-bg {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 8;
            left: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.4);
            border-radius: 4px;
          }
        }
      }

      .swiper-wrapper::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
    }

    .ind-banner-box {
      width: 960px;
      height: 100%;
      margin: auto;
      // overflow: hidden;
      position: relative;
    }

    .ind-banner-ul {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
